<div class="page-container">
  <!-- Breadcrumb + status share one row to keep the top compact. -->
  <div class="page-toolbar">
    <app-breadcrumb [items]="breadcrumbItems"></app-breadcrumb>
    <div class="status-dropdown-container">
      <div class="status-label-container">
        <label for="user-status" class="status-label">{{ 'pages.profile.status.label' | transloco }}</label>
        <span class="status-tooltip-icon" [title]="'pages.profile.status.tooltip' | transloco">?</span>
        :
      </div>
      <div class="status-dropdown-wrapper"
           [class.status-available]="selectedStatus === 'Available'"
           [class.status-unavailable]="selectedStatus === 'Unavailable'"
           [class.status-hired]="selectedStatus === 'Hired'">
        <span class="status-dot" aria-hidden="true"></span>
        <select
          id="user-status"
          class="status-dropdown"
          [class.status-available]="selectedStatus === 'Available'"
          [class.status-unavailable]="selectedStatus === 'Unavailable'"
          [class.status-hired]="selectedStatus === 'Hired'"
          [(ngModel)]="selectedStatus"
          (change)="onStatusChange($event)"
          [disabled]="isLoadingStatuses || isUpdatingStatus"
        >
          <option *ngFor="let status of userStatuses" [value]="status">
            {{ ('pages.profile.status.' + status.toLowerCase()) | transloco }}
          </option>
        </select>
      </div>
      <span *ngIf="isUpdatingStatus" class="status-spinner">⟳</span>
    </div>
  </div>

  <app-profile-form [profileSettings]="profileSettings"></app-profile-form>
</div>
